import { Skeleton } from '@radix-ui/themes'

const ChartSkeleton = ({ fullWidth = false }) => {
  return (
    <div className={`p-4 bg-cardFill ${fullWidth ? 'w-full h-[450px]' : 'w-1/2 h-[400px]'}`}>
      {/* Chart Title */}
      <Skeleton className="h-6 w-40 mb-4" />

      {/* Chart Body */}
      <div className="flex flex-col gap-4">
        {/* Simulated Y-Axis */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-3 w-full" />
        </div>

        {/* Simulated Chart Bars / Lines */}
        <Skeleton className="h-[250px] w-full" />

        {/* Simulated X-Axis */}
        <div className="flex justify-around mt-2">
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-3 w-12" />
        </div>
      </div>
    </div>
  )
}

export default ChartSkeleton
